import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from '../../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../../support/excel-pdf/excel-pdf.component';
import { EditorComponent } from '../../editor/editor.component';
import { GridReorderComponent } from '../../grid-reorder/grid-reorder.component';

export interface QmsBusinessAreaInterface {
  qmsBusinessAreaVwPk: {
    businessAreaId: number;
  }
  module: string;
  taskRequestedAt: string;
  listOfBusinessArea: string;
  isActive: boolean;
  isFactoryData: boolean;
  createdOn: Date;
  createdBy: number;
  updatedOn: Date;
  updatedBy: number;
  createdByUser: string;
  updatedByUser: string;
  operation: string;
  deleteReason: string;
}

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-qms-businessarea',
  templateUrl: './qms-businessarea.component.html',
  styleUrls: ['./qms-businessarea.component.scss']
})

export class QmsBusinessareaComponent implements OnInit {

  isProcessing: boolean;
  _temp: any = {};
  columnLists: any = {};
  qmsQuestionnaireTemplateDataForGrid: any = [];
  qmsQuestionnaireTemplateDataForGridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  grid: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddModule: any = null;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.qmsQuestionnaireTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsQuestionnaireTemplateDataForGrid
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.qmsQuestionnaireTemplateDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.qmsQuestionnaireTemplateDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.qmsQuestionnaireTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        throw new Error(error);
      }
    })
    this.isProcessing = false;

  }
  htmlContent: any;

  reportObj: any = {};
  getcallMethod() {
    this.isProcessing = true;
    if (!this.selectedmoduleValue) {
      this.mainModuleValue = document.getElementById('mainModule') as HTMLInputElement;
      this.mainModuleRequiredMsg = document.getElementById('mainModule-required-msg') as HTMLInputElement;
      this.mainModuleValue.style.border = '';
      this.mainModuleRequiredMsg.style.display = 'none';
    }
    this.qmsQuestionnaireTemplateDataForGrid = [];
    const data = {

      gridName: "BUSINESSAREA"
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_BUSINESSAREA_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          ...(this.selectedmoduleValue && { module: this.selectedmoduleValue ?? null })
        }

        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.qmsQuestionnaireTemplateDataForGrid = response1;
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            for (const invisibleCol of this.columnLists.invisibleColumnarray) {
              const index = this.columnLists.columnsListarray.indexOf(invisibleCol);

              if (index !== -1) {
                this.columnLists.columnsListarray.splice(index, 1);
                this.columnLists.fieldColumnarray.splice(index, 1);
                this.columnLists.fieldSizeListArray.splice(index, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const rowData of this.qmsQuestionnaireTemplateDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    rowData[dataType.columnName] = rowData[dataType.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
              this.labelcall()
            });
            this.message.gridList = this.qmsQuestionnaireTemplateDataForGrid;
            this.collectionSize = this.qmsQuestionnaireTemplateDataForGrid.length;
            this.totalPages = Math.ceil(this.qmsQuestionnaireTemplateDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {

      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsQuestionnaireTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsQuestionnaireTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.qmsQuestionnaireTemplateDataForGridTemp = this.qmsQuestionnaireTemplateDataForGrid;
      this.pager = this.paginationService.getPager(this.qmsQuestionnaireTemplateDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.qmsQuestionnaireTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.qmsQuestionnaireTemplateDataForGrid == undefined) {
        return this.qmsQuestionnaireTemplateDataForGrid;
      }
      if (!this.qmsQuestionnaireTemplateDataForGrid.length) {
        return this.qmsQuestionnaireTemplateDataForGrid;
      }
      if (filter) {
        this.qmsQuestionnaireTemplateDataForGridTemp = this.qmsQuestionnaireTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        })
      } else {
        this.qmsQuestionnaireTemplateDataForGridTemp = this.qmsQuestionnaireTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }

      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsQuestionnaireTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;


      const valueA = a[key as keyof QmsBusinessAreaInterface];
      const valueB = b[key as keyof QmsBusinessAreaInterface];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;

    for (const row of this.qmsQuestionnaireTemplateDataForGrid) {
      row.childCheckBoxs = isChecked;
    }
  }


  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.qmsQuestionnaireTemplateDataForGrid[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.BUSINESS_AREA_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.qmsQuestionnaireTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  }

  ngOnInit() {
    this.dropDownDataForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') || '{}');
    this.selectBoxForModule();
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  dropDownDataForModule: any = [];
  getOneQmsNonorgModuleStagesListDetails: any = [];

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 4,
  };

  selectedModule: any = null;
  selectedModuleDisplayExp: any = null;
  selectedModuleValueExp: any = null;
  moduleListDropdown: any = [];
  selectedmoduleValue: any = null;
  mainModuleValue: any;
  mainModuleValueSelect: any = null;

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectBoxForModule() {
    this.moduleListDropdown = [];
    const excludedCodes = new Set(['BP', 'CC', 'DOCS', 'OOS', 'TRN']);
    for (const item of this.dropDownDataForModule) {
      if (!excludedCodes.has(item.codelistCode)) {
        this.moduleListDropdown.push({
          valueExp: item.codelistCode,
          displayExp: item.codelistName
        });
      }
    }
  }

  mainModulesearchTxt: any;

  onMainModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.mainModuleValueSelect = item.valueExp;
          this.getcallMethod();
        } else {
          this.mainModuleValueSelect = null;
        }
      } else {
        this.mainModuleValueSelect = undefined;
      }
    }
  }

  modulesearchTxt: any;

  focusEmpty() {
    console.log();
  }

  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.isProcessing = true;
          if (item.valueExp) {
            this.selectedModuleValueExp = item.valueExp;
          } else {
            this.selectedModuleValueExp = item;
          }
          this.isProcessing = false;
        }
      }
    }
  }

  qmsBusinesssAreaFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  mainModuleRequiredMsg: any;
  openAddPopup() {
    if (this.selectedmoduleValue) {
      this.mainModuleValue = document.getElementById('mainModule') as HTMLInputElement;
      this.mainModuleRequiredMsg = document.getElementById('mainModule-required-msg') as HTMLInputElement;
      this.mainModuleValue.style.border = '';
      this.mainModuleRequiredMsg.style.display = 'none';
      this.visibleAddButton = true;
      this.visibleEditButton = false;
      this.operationFlag = 'ADD';
      this.popupDataTitle.title = "Create QMS Business Area";
      if (this.mainModuleValueSelect) {
        let data = this.moduleListDropdown.filter((x: any) => x.valueExp === this.mainModuleValueSelect);
        if (data.length > 0) {
          this.selectedModule = data[0].valueExp;

        }
      }
      this.qmsBusinesssAreaFieldData.taskRequestedAt = '';
      this.qmsBusinesssAreaFieldData.listOfBusinessArea = '';
      this.qmsBusinesssAreaFieldData.isActive = true;
      this.qmsBusinesssAreaFieldData.isFactoryData = false;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    } else {
      this.mainModuleValue = document.getElementById('mainModule') as HTMLInputElement;
      this.mainModuleRequiredMsg = document.getElementById('mainModule-required-msg') as HTMLInputElement;
      this.mainModuleValue.style.border = '1px solid red';
      this.mainModuleRequiredMsg.style.display = 'block';

    }
  }

  previousData: any;
  previousDataECId: any;
  getQmsBusinessAreaDetails: any = [];
  filteredModuleValue: any = [];
  filteredTaskRequestedAtValue: any = [];
  openEditPopup(qmsBusinesssAreaFieldData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.previousData = qmsBusinesssAreaFieldData;

    if (editFlag) {
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.operationFlag = 'EDIT';
      this.popupDataTitle.title = "Update QMS Business Area";
    } else {
      this.visibleAddButton = false;
      this.visibleEditButton = false;
      this.popupDataTitle.title = "Info";
    }

    this.previousDataECId = qmsBusinesssAreaFieldData.BUSINESS_AREA_ID;
    this.appService.getQmsBusinessAreaByBusinessAreaId(this.previousDataECId).subscribe({
      next: (response: any) => {
        this.getQmsBusinessAreaDetails = response

        this.qmsBusinesssAreaFieldData.businessAreaId = this.getQmsBusinessAreaDetails.qmsBusinessAreaVwPk.businessAreaId;
        this.qmsBusinesssAreaFieldData.listOfBusinessArea = this.getQmsBusinessAreaDetails.listOfBusinessArea;
        this.qmsBusinesssAreaFieldData.taskRequestedAt = this.getQmsBusinessAreaDetails.taskRequestedAt;
        this.qmsBusinesssAreaFieldData.updateReason = '';
        this.qmsBusinesssAreaFieldData.isActive = this.getQmsBusinessAreaDetails.isActive == 'Y';
        this.qmsBusinesssAreaFieldData.isFactoryData = this.getQmsBusinessAreaDetails.isFactoryData == "Y";
        if (this.getQmsBusinessAreaDetails.module) {
          const matchingModule = this.dropDownDataForModule?.find((item: any) => item.codelistCode == this.getQmsBusinessAreaDetails.module);
          if (!matchingModule) {
            this.oddModule = this.getQmsBusinessAreaDetails.module;
            this.moduleListDropdown.push({
              valueExp: this.getQmsBusinessAreaDetails.module,
              displayExp: this.getQmsBusinessAreaDetails.module
            })
          }
          this.selectedModule = this.getQmsBusinessAreaDetails.module;
        }
        this.onModuleSelect(true, this.getQmsBusinessAreaDetails.module);
        this.isProcessing = false;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      }, error: (error) => {
        this.isProcessing = false;
      }
    })
  }

  moduleValue: any;
  taskRequestedAtValue: any;
  listOfBusinessAreaValue: any;

  moduleRequiredMsg: any;
  taskRequestedAtRequiredMsg: any;
  listOfBusinessAreaRequiredMsg: any;
  updateReq: any;
  updateReqMsg: any;

  fieldValidation() {
    this.moduleValue = document.getElementById('module') as HTMLInputElement;
    this.taskRequestedAtValue = document.getElementById('taskRequestedAt') as HTMLInputElement;
    this.updateReq = document.getElementById('updateReason') as HTMLInputElement;
    this.updateReqMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;
    this.moduleRequiredMsg = document.getElementById('module-required-msg') as HTMLInputElement;
    this.taskRequestedAtRequiredMsg = document.getElementById('taskRequestedAt-required-msg') as HTMLInputElement;

    if (this.visibleEditButton) {
      if (this.qmsBusinesssAreaFieldData.updateReason) {
        this.updateReq.style.border = '';
        this.updateReqMsg.style.display = 'none';
      } else {
        this.updateReq.style.border = '1px solid red';
        this.updateReqMsg.style.display = 'block';
      }
    }
    if (this.selectedModule) {
      this.moduleValue.style.border = '';
      this.moduleRequiredMsg.style.display = 'none';
    } else {
      this.moduleValue.style.border = '1px solid red';
      this.moduleRequiredMsg.style.display = 'block';
    }
    if (this.taskRequestedAtValue.value == "") {
      this.taskRequestedAtValue.style.border = '1px solid red';
      this.taskRequestedAtRequiredMsg.style.display = 'block';
    } else {
      this.taskRequestedAtValue.style.border = '';
      this.taskRequestedAtRequiredMsg.style.display = 'none';
    }

  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  addAndEditFunction(qmsBusinesssAreaFieldData: any) {
    this.isProcessing = true;
    if (!this.selectedmoduleValue || this.qmsBusinesssAreaFieldData.taskRequestedAt == '' || (this.visibleEditButton && !this.qmsBusinesssAreaFieldData.updateReason)) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      if (this.qmsBusinesssAreaFieldData.listOfBusinessArea == "" || this.qmsBusinesssAreaFieldData.listOfBusinessArea == " ") {
        this.qmsBusinesssAreaFieldData.listOfBusinessArea = null;
      }
      let data = {
        taskRequestedAt: qmsBusinesssAreaFieldData.taskRequestedAt,
        listOfBusinessArea: qmsBusinesssAreaFieldData.listOfBusinessArea,
        isActive: qmsBusinesssAreaFieldData.isActive ? 'Y' : 'N',
        updateReason: qmsBusinesssAreaFieldData.updateReason,
        isFactoryData: 'N',/* qmsBusinesssAreaFieldData.isFactoryData ? 'Y' : 'N', */
        module: this.selectedmoduleValue ?? null
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createQmsBusinessArea(data).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.isProcessing = false;
              this.ngOnInit();
              this.getcallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedData = {
          ...data,
          qmsBusinessAreaVwPk: {
            businessAreaId: this.previousDataECId,
          },
        };

        this.appService.updateQmsBusinessArea(modifiedData).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.isProcessing = false;
              this.ngOnInit();
              this.getcallMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: Response.resultType == 'S' ? 5000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = '';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteQmsBusinessAreaBusinessId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete QMS Business Area";
    this.deleteQmsBusinessAreaBusinessId = deleteRowData.BUSINESS_AREA_ID;
    if (this.qmsBusinesssAreaFieldData.deleteReason != undefined) {
      this.qmsBusinesssAreaFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction(qmsBusinesssAreaFieldData: any) {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      qmsBusinesssAreaFieldData.qmsBusinessAreaVwPk = {
        businessAreaId: this.deleteQmsBusinessAreaBusinessId
      };

      qmsBusinesssAreaFieldData.deleteReason = this.qmsBusinesssAreaFieldData.deleteReason;
      this.appService.deleteQmsBusinessArea(qmsBusinesssAreaFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  selectedColumns: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  array: any = [];
  openReportPopup(item: any) {
    this.selectedColumns = [];
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
  }

  generateReport(value: any) {
    const timestamp = Date.now();

    const formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit', month: 'short', year: 'numeric',
    }).format(new Date(timestamp)).replaceAll(/[, ]/g, (match) => match === ',' ? '' : '_');

    const fileType = value === 'Excel' ? 'xlsx' : 'pdf';

    const fileName = `BusinessArea_${formattedDate}.${fileType}`;
    const reportTitle = 'Business Area Report';

    if (value === 'Excel') {
      const excelData = {
        ...this.reportObj, title: reportTitle, columns: this.selectedColumns.join(',')
      };
      this.downloadExcelReport(excelData, fileName);

    } else {
      const pdfData = {
        ...this.reportObj, title: reportTitle, columns: this.selectedColumns.join(','), logoId: 0, isSaveRep: 'N'
      };
      this.downloadPdfReport(pdfData, fileName);
    }
  }


  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel || this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  };

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Business Area Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.BUSINESS_AREA_ID;
    this.auditTrail.gridName = 'BUSINESSAREA';
    this.auditTrail.report_And_Popup_Name = 'Business Area Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };


  downloadExcelReport(data: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadexcel(data).subscribe({
      next:
        (response: any) => {
          let dataType = response.type;
          let binaryData = [];
          binaryData.push(response);
          let downloadLink = document.createElement('a');
          downloadLink.href = globalThis.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        }, error:
        (error) => {
          this.isProcessing = false;
          throw error;
        }
    })
  }

  downloadPdfReport(pdfData: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadPdf(pdfData).subscribe({
      next:
        (response: any) => {
          let dataType = response.type;
          let binaryData = [];
          binaryData.push(response);
          let downloadLink = document.createElement('a');
          downloadLink.href = globalThis.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (fileName)
            downloadLink.setAttribute('download', fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.isProcessing = false;
        }, error:
        (error) => {
          this.isProcessing = false;
          throw error;
        }
    })
  }


}
